export default {
  title: '404',
  description:
    'Sorry, but the page you are trying to access does not exist or is temporarily unavailable. This could be due to a misspelled web address, an outdated link, or the page has been removed.',
  homelink: 'Try going back to the front page',
};
